import { Fragment } from 'react'

import reactifyWc from './reactify-wc'

// 视图容器
export const CoverImage = /* @__PURE__ */ reactifyWc('taro-cover-image-core')
export const CoverView = /* @__PURE__ */ reactifyWc('taro-cover-view-core')
export const MatchMedia = /* @__PURE__ */ reactifyWc('taro-match-media-core')
export const MovableArea = /* @__PURE__ */ reactifyWc('taro-movable-area-core')
export const MovableView = /* @__PURE__ */ reactifyWc('taro-movable-view-core')
export const PageContainer = /* @__PURE__ */ reactifyWc('taro-page-container-core')
export const RootPortal = /* @__PURE__ */ reactifyWc('taro-root-portal-core')
export const ScrollView = /* @__PURE__ */ reactifyWc('taro-scroll-view-core')
export const ShareElement = /* @__PURE__ */ reactifyWc('taro-share-element-core')
export const Swiper = /* @__PURE__ */ reactifyWc('taro-swiper-core')
export const SwiperItem = /* @__PURE__ */ reactifyWc('taro-swiper-item-core')
export const View = /* @__PURE__ */ reactifyWc('taro-view-core')

// 基础内容
export const Icon = /* @__PURE__ */ reactifyWc('taro-icon-core')
export const Progress = /* @__PURE__ */ reactifyWc('taro-progress-core')
export const RichText = /* @__PURE__ */ reactifyWc('taro-rich-text-core')
export const Text = /* @__PURE__ */ reactifyWc('taro-text-core')

// 表单组件
export const Button = /* @__PURE__ */ reactifyWc('taro-button-core')
export const Checkbox = /* @__PURE__ */ reactifyWc('taro-checkbox-core')
export const CheckboxGroup = /* @__PURE__ */ reactifyWc('taro-checkbox-group-core')
export const Editor = /* @__PURE__ */ reactifyWc('taro-editor-core')
export const Form = /* @__PURE__ */ reactifyWc('taro-form-core')
export { default as Input } from './input'
export const KeyboardAccessory = /* @__PURE__ */ reactifyWc('taro-keyboard-accessory-core')
export const Label = /* @__PURE__ */ reactifyWc('taro-label-core')
export const Picker = /* @__PURE__ */ reactifyWc('taro-picker-core')
export const PickerView = /* @__PURE__ */ reactifyWc('taro-picker-view-core')
export const PickerViewColumn = /* @__PURE__ */ reactifyWc('taro-picker-view-column-core')
export const Radio = /* @__PURE__ */ reactifyWc('taro-radio-core')
export const RadioGroup = /* @__PURE__ */ reactifyWc('taro-radio-group-core')
export const Slider = /* @__PURE__ */ reactifyWc('taro-slider-core')
export const Switch = /* @__PURE__ */ reactifyWc('taro-switch-core')
export const Textarea = /* @__PURE__ */ reactifyWc('taro-textarea-core')

// 导航
export const FunctionalPageNavigator = /* @__PURE__ */ reactifyWc('taro-functional-page-navigator-core')
export const Navigator = /* @__PURE__ */ reactifyWc('taro-navigator-core')
export const NavigationBar = /* @__PURE__ */ reactifyWc('taro-navigation-bar-core')

// 媒体组件
export const Audio = /* @__PURE__ */ reactifyWc('taro-audio-core')
export const Camera = /* @__PURE__ */ reactifyWc('taro-camera-core')
export const Image = /* @__PURE__ */ reactifyWc('taro-image-core')
export const LivePlayer = /* @__PURE__ */ reactifyWc('taro-live-player-core')
export const LivePusher = /* @__PURE__ */ reactifyWc('taro-live-pusher-core')
export const Video = /* @__PURE__ */ reactifyWc('taro-video-core')
export const VoipRoom = /* @__PURE__ */ reactifyWc('taro-voip-room-core')

// 地图
export const Map = /* @__PURE__ */ reactifyWc('taro-map-core')

// 画布
export const Canvas = /* @__PURE__ */ reactifyWc('taro-canvas-core')

// 开放能力
export const Ad = /* @__PURE__ */ reactifyWc('taro-ad-core')
export const AdCustom = /* @__PURE__ */ reactifyWc('taro-ad-custom-core')
export const OfficialAccount = /* @__PURE__ */ reactifyWc('taro-official-account-core')
export const OpenData = /* @__PURE__ */ reactifyWc('taro-open-data-core')
export const WebView = /* @__PURE__ */ reactifyWc('taro-web-view-core')

// 页面属性配置节点
export const PageMeta = /* @__PURE__ */ reactifyWc('taro-page-meta-core')

// 其他
export const Block = Fragment
export const CustomWrapper = /* @__PURE__ */ reactifyWc('taro-custom-wrapper-core')
